module.exports = __webpack_public_path__ + "img/next.c2c6e72a.svg";